export class AddFacebookLocationFeedCommand {
  constructor(
    public name: string,
    public title: string,
    public hubName: string,
    public filterByCity: string,
    public points: {
      lat: number;
      lng: number;
    }[],
    public lat: number,
    public lng: number,
    public radius: number,
    public stateAbbr: string,
    public tags = 'Visitor Posts',
    public socialName = 'facebook',
    public typeToPull = null,
    public moderate = true,
    public type = 'geo'
  ) {}
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/hub/event/add.facebook.location.feed.command.ts